/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeaderSectionGenerated
 */
export interface HeaderSectionGenerated {
    /**
     * 
     * @type {string}
     * @memberof HeaderSectionGenerated
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderSectionGenerated
     */
    logoUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HeaderSectionGenerated
     */
    useCompanyLogo?: boolean;
}

/**
 * Check if a given object implements the HeaderSectionGenerated interface.
 */
export function instanceOfHeaderSectionGenerated(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function HeaderSectionGeneratedFromJSON(json: any): HeaderSectionGenerated {
    return HeaderSectionGeneratedFromJSONTyped(json, false);
}

export function HeaderSectionGeneratedFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeaderSectionGenerated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
        'logoUrl': !exists(json, 'logo_url') ? undefined : json['logo_url'],
        'useCompanyLogo': !exists(json, 'use_company_logo') ? undefined : json['use_company_logo'],
    };
}

export function HeaderSectionGeneratedToJSON(value?: HeaderSectionGenerated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'logo_url': value.logoUrl,
        'use_company_logo': value.useCompanyLogo,
    };
}

